export default function (state, val) {
    state.tab = val;
}